import JSURL from 'jsurl';
import { useMemo } from 'react';

const parseReviewer = ({
  i, n, t, r, c,
}) => ({
  id: i,
  name: n,
  timeToReview: t,
  totalReviews: r,
  totalComments: c,
});

const sortByReviews = (a, b) => b.totalReviews - a.totalReviews;

const buildData = (input) => {
  const parsed = JSURL.parse(input);

  return {
    user: {
      id: parsed?.u?.i,
      name: parsed?.u?.n,
    },
    period: parsed?.p,
    reviewers: (parsed?.r || []).map(parseReviewer).sort(sortByReviews),
  };
};

export const useUrlData = (input) => useMemo(() => {
  try {
    return buildData(input);
  } catch {
    return { error: true };
  }
}, [input]);
